import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-[#FBF8F3]" data-id="element-0" data-mp="23ut9lxqjzq85">
      <MetaPixel data-id="element-1" data-mp="3ikqzm1my986s" />
      <Hero data-id="element-2" data-mp="3ij64oawq3n8e" />
      <main data-id="element-3" data-mp="3ijfu9xduvsdk">
        <StatsBar data-id="element-4" data-mp="3ihv22ef0kliv" />
        <BeforeAfter data-id="element-5" data-mp="3mljat0fdtn5p" />
        <PainPoints data-id="element-6" data-mp="3ml12h5fg3ihf" />
        <Volumes data-id="element-7" data-mp="3mkhofzsx1e8o" />
        <Bonuses data-id="element-8" data-mp="3mjzpgvevclx2" />
        <Offer data-id="element-9" data-mp="3mjgclt42snpw" />
        <Guarantee data-id="element-10" data-mp="3rc9co3oln7vn" />
        <Testimonials data-id="element-11" data-mp="3rbrcwx2qabiz" />
        <Author data-id="element-12" data-mp="3rdkgg3i1ofmr" />
        <FAQ data-id="element-13" data-mp="3rd1a7k1rbfok" />
        <FinalCTA data-id="element-14" data-mp="3recc1ebn6dd1" />
      </main>
      <Footer data-id="element-15" data-mp="6hrlipoilfp" />
      <FloatingCTA data-id="element-16" data-mp="682rygdekbl" />
      <PurchasePopup data-id="element-17" data-mp="5gel8p3rovc" />
    </div>;
}